<template>
    <nav class="nav">
        <router-link to="/">Home</router-link>
        <router-link to="/about">About</router-link>
    </nav>
</template>

<script>
    export default {
        name: 'navigation',
    }
</script>
